import { LOADING, SET_MESSAGE } from "../../Actions/Types";
import { AddBillingAddressApi, deleteBillingAddressApi, getBillingAddressApi, getCountryListApi, makeDefaultBillingAddressApi, UpdateBillingAddressApi } from "../../Api/BillingAddressApi";
import { BillingAddressPropTypes } from "../../PropTypes/BillingAddressPropTypes";
import { getUserDetailsService } from "../../Services/UserAction/LoginActionService";

const AddBillingAddressService = (
  name: string,
  lastName: string, // access token
  streetAddress: string, // access token
  country: string, // access token
  pincode: string, // access token
  accessToken:string,
  vat:string,
  setBillingAddressListData: Function, // dispatch function to store redux data
  setLoadingBillingAddressList: Function, // dispatch function to store redux data
  setShowBillingAddressPopup: Function, // dispatch function to store redux data
  dispatch: Function, // dispatch function to store redux data
  t: Function, // i18next t function
  resetForm: Function, // resetForm t function,
) => {
  // Set Loading
  dispatch({
    type: LOADING,
    payload: true,
  });

  // api to perform action on bulk domains
  AddBillingAddressApi(name,lastName,streetAddress,country, pincode, vat, accessToken).then((response) => {
    if (response.status === 200) {
      // remove Loading
       if (response.data) {
            
            // service to get card list
            getBillingAddressService(accessToken, setBillingAddressListData, setLoadingBillingAddressList, dispatch, t);

        }
      dispatch({
        type: LOADING,
        payload: false,
      });

      setShowBillingAddressPopup(false)
      dispatch({
        type: SET_MESSAGE,
        payload: {
          toast_message: t(response.message),
          toast_type: "success",
        },
      });

      resetForm()
    } else {
      // remove Loading
      dispatch({
        type: LOADING,
        payload: false,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          toast_message: t(response.error),
          toast_type: "danger",
        },
      });
    }
  });
};

const UpdateBillingAddressService = (
  id:number,
  name: string,
  lastName: string, // access token
  streetAddress: string, // access token
  country: string, // access token
  pincode: string, // access token
  accessToken:string,
  vat:string,
  setBillingAddressListData: Function, // dispatch function to store redux data
  setLoadingBillingAddressList: Function, // dispatch function to store redux data
  setShowBillingAddressPopup: Function, // dispatch function to store redux data
  dispatch: Function, // dispatch function to store redux data
  t: Function, // i18next t function,
  resetForm: Function, // resetForm t function,
) => {
  // Set Loading
  dispatch({
    type: LOADING,
    payload: true,
  });

  // api to perform action on bulk domains
  UpdateBillingAddressApi(id, name,lastName,streetAddress,country, pincode,vat, accessToken).then((response) => {
    if (response.status === 200) {
      // remove Loading
       if (response.data) {
            
            // service to get card list
            getBillingAddressService(accessToken, setBillingAddressListData, setLoadingBillingAddressList, dispatch, t);

        }
      dispatch({
        type: LOADING,
        payload: false,
      });

      setShowBillingAddressPopup(false)
      dispatch({
        type: SET_MESSAGE,
        payload: {
          toast_message: t(response.message),
          toast_type: "success",
        },
      });

      resetForm()
    } else {
      // remove Loading
      dispatch({
        type: LOADING,
        payload: false,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          toast_message: t(response.error),
          toast_type: "danger",
        },
      });
    }
  });
};


// service to get card list
const getBillingAddressService = (
    accessToken: string, // access token
    setBillingAddressListData: Function, // function to set card list
    setLoadingBillingAddressList: Function, // function to set loader
    dispatch: Function, // function to store redux data
    t: Function // i18next t function
) => {

    // set loader
    setLoadingBillingAddressList(true);

    // API to get card list
    getBillingAddressApi(accessToken).then(response => {
        // check response data is available
        if (response.data) {
            setBillingAddressListData(response.data);
            if (response.data.length > 0) {
              const checkIsDefaultFlag = response.data.filter((d:BillingAddressPropTypes) => d.is_default === 1)
              if (checkIsDefaultFlag.length === 0) {
                makeDefaultBillingAddressService(accessToken, response.data[0].id, setBillingAddressListData, setLoadingBillingAddressList, dispatch, t)
              }
            }
        }
        // remove loader
        setLoadingBillingAddressList(false);
    })
}

// service to get card list
const getCountryListService = (
    accessToken: string, // access token
    setCountryList: Function, // function to set loader
) => {

    // API to get card list
    getCountryListApi(accessToken).then(response => {
        // check response data is available
        if (response.data) {
            setCountryList(response.data.map((d:any) => {
              return {
                value: String(d.id),
                label: d.name
              }
            }));
        }
    })
}

// service to set default card
const makeDefaultBillingAddressService = (
    accessToken: string, // access token 
    defaultBillingAddressID: number, // card Id
    setBillingAddressListData: Function, // function to set card list
    setLoadingBillingAddressList: Function, // function to set card list loader
    dispatch: Function, // function to store redux data
    t: Function // i18next t function
) => {

    // API to set default card
    makeDefaultBillingAddressApi(accessToken, defaultBillingAddressID).then(response => {
        // check if response data is available
        if (response.data) {
            
            // service to get card list
            getBillingAddressService(accessToken, setBillingAddressListData, setLoadingBillingAddressList, dispatch, t);

              dispatch({
              type: SET_MESSAGE,
              payload: {
                toast_message: t(response.message),
                toast_type: "success",
              },
            });

        }
        
    })
}

// service to delete card
const deleteBillingAddressService = (
    accessToken: string, // access token
    defaultBillingAddressID: number, // card Id
    setShowDeleteCardPopupLoading: Function, // function to show/hide delete card popup loading
    setBillingAddressListData: Function, // function to set card list
    setLoadingBillingAddressList: Function, // function to set card list loading
    setDeleteBillingAddressPopup: Function, // function to show/hide delete card popup
    dispatch: Function, // function to store redux data
    t: Function // i18next t function
) => {

    // set loader
    setShowDeleteCardPopupLoading(true);

    // API to delete card
    deleteBillingAddressApi(accessToken, defaultBillingAddressID).then(response => {
        // check if response data is available
        if (response) {
            //setCardListData(response.Data);

            // service to get card list
            getBillingAddressService(accessToken, setBillingAddressListData, setLoadingBillingAddressList, dispatch, t);

            // hide delete card popup
            setDeleteBillingAddressPopup(false)

            // dispatch card delete success message
            dispatch({
                type: SET_MESSAGE,
                payload: {
                    "toast_message": t('Billing Address Deleted Successfully!'),
                    "toast_type": "success"
                }
            })
        }
        // remove popup loading
        setShowDeleteCardPopupLoading(false);
    })
}


export {
  AddBillingAddressService,
  getBillingAddressService,
  makeDefaultBillingAddressService,
  deleteBillingAddressService,
  getCountryListService,
  UpdateBillingAddressService
};
